export function normalizeSalespersonSlug(slug) {
  if (!slug || typeof slug !== 'string') return '';
  const decodedSlug = decodeURIComponent(slug);
  return decodedSlug
    .toLowerCase()
    .replace(/\+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function buildSalespersonSlugFromName(name) {
  if (!name || typeof name !== 'string') return '';
  return normalizeSalespersonSlug(name);
}

export function employeeMatchesSalespersonSlug(employee, slug) {
  const normalizedSlug = normalizeSalespersonSlug(slug);
  if (!normalizedSlug || !employee) return false;

  const permalink = typeof employee.permalink === 'string' ? employee.permalink.toLowerCase() : '';
  const wpSlug = typeof employee.slug === 'string' ? employee.slug.toLowerCase() : '';
  const nameSlug = buildSalespersonSlugFromName(employee.name);

  return (
    permalink === normalizedSlug ||
    wpSlug === normalizedSlug ||
    nameSlug === normalizedSlug
  );
}
